import { render, staticRenderFns } from "./IcoFaceGrin.vue?vue&type=template&id=7ed6ad92"
import script from "./IcoFaceGrin.vue?vue&type=script&lang=js"
export * from "./IcoFaceGrin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports